//      
import memoizeOne from 'memoize-one';
import {               } from 'css-box-model';
                                                  
import { patch } from './position';

// TODO: memoization needed?
export default memoizeOne(function getDisplacedBy(
  axis      ,
  displaceBy          ,
)              {
  const displacement         = displaceBy[axis.line];
  return {
    value: displacement,
    point: patch(axis.line, displacement),
  };
});



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/get-displaced-by.js